import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-11 w-full min-w-0 rounded-lg bg-ink-850 px-3.5 text-[0.95rem] text-fg ring-1 ring-line-strong transition-shadow placeholder:text-fg-subtle',
        'focus:outline-none focus:ring-2 focus:ring-volt-500/70 aria-invalid:ring-danger/70',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export function Label({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-sm font-medium text-fg-muted', className)} {...props} />;
}
